import React from "react";
import { ProfileIcon } from "components/SVG";
import { profileButton } from "./ProfileButton.css";

type Props = {
  onClick: () => void;
};

export const ProfileButton: React.FC<Props> = ({ onClick }) => {
  return (
    <button
      role="menuitem"
      aria-label="Toggle account menu"
      type="button"
      className={profileButton}
      data-testid="profile-button"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <ProfileIcon />
      <p>Profile</p>
    </button>
  );
};
